/* Vec2STL storefront configurator -- 1836 Creations */
(function () {
  const $ = (id) => document.getElementById(id);
  const root = document.querySelector('.v2s');
  if (!root) return;

  const fileIn = $('v2s-file'), drop = $('v2s-drop'), dropText = $('v2s-drop-text'), thumb = $('v2s-thumb');
  const widthIn = $('v2s-width'), typeSel = $('v2s-type');
  const genBtn = $('v2s-gen'), bar = $('v2s-bar'), fill = $('v2s-fill'), statusEl = $('v2s-status'), errEl = $('v2s-error');
  const quote = $('v2s-quote'), form = $('v2s-form');
  const MAX_FILE_MB = 10;

  let pyodide = null, ready = false, imgBytes = null, imgName = 'art.png', lastResult = null, stale = true;

  const setStatus = (m) => { statusEl.textContent = m; };
  const showError = (m) => { errEl.textContent = m; errEl.hidden = !m; };
  const money = (n) => '$' + Number(n).toFixed(2);

  function refreshButton() {
    genBtn.disabled = !(ready && imgBytes);
    genBtn.textContent = !ready ? 'Preparing 3D engine…' : (lastResult && !stale ? 'Regenerate preview' : 'Generate preview');
  }
  function markStale() {
    stale = true; quote.hidden = true; $('v2s-variant').value = '';
    refreshButton();
  }

  // ---------- file ----------
  fileIn.addEventListener('change', () => {
    showError('');
    const f = fileIn.files && fileIn.files[0];
    if (!f) return;
    if (!/^image\/(png|jpeg)$/.test(f.type)) { showError('Please upload a PNG or JPG image.'); fileIn.value = ''; return; }
    if (f.size > MAX_FILE_MB * 1024 * 1024) { showError(`File is over ${MAX_FILE_MB} MB. Please upload a smaller image.`); fileIn.value = ''; return; }
    imgName = 'art' + (f.type === 'image/png' ? '.png' : '.jpg');
    const r = new FileReader();
    r.onload = (e) => {
      imgBytes = new Uint8Array(e.target.result);
      thumb.src = URL.createObjectURL(f); thumb.hidden = false;
      dropText.textContent = f.name; drop.classList.add('has-file');
      markStale();
    };
    r.readAsArrayBuffer(f);
  });
  widthIn.addEventListener('input', markStale);
  typeSel.addEventListener('change', () => { if (lastResult && !stale) applyQuote(lastResult); });

  // ---------- 3D viewer ----------
  let scene, camera, renderer, controls, mesh;
  function initViewer() {
    const box = $('v2s-viewer');
    scene = new THREE.Scene(); scene.background = new THREE.Color(0xf0ece1);
    camera = new THREE.PerspectiveCamera(45, box.clientWidth / box.clientHeight, 0.1, 5000);
    camera.up.set(0, 0, 1);
    renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setSize(box.clientWidth, box.clientHeight);
    box.appendChild(renderer.domElement);
    controls = new THREE.OrbitControls(camera, renderer.domElement);
    const l = new THREE.DirectionalLight(0xffffff, 0.9); l.position.set(1, -1, 2); scene.add(l);
    scene.add(new THREE.AmbientLight(0x888888));
    window.addEventListener('resize', () => {
      camera.aspect = box.clientWidth / box.clientHeight; camera.updateProjectionMatrix();
      renderer.setSize(box.clientWidth, box.clientHeight);
    });
    (function loop() { requestAnimationFrame(loop); controls.update(); renderer.render(scene, camera); })();
  }
  function showMesh(buf) {
    const empty = root.querySelector('.v2s-empty'); if (empty) empty.remove();
    if (mesh) { scene.remove(mesh); mesh.geometry.dispose(); }
    const g = new THREE.STLLoader().parse(buf); g.computeBoundingBox(); g.center();
    mesh = new THREE.Mesh(g, new THREE.MeshStandardMaterial({ color: 0xd1b482, metalness: 0.1, roughness: 0.8 }));
    scene.add(mesh);
    const s = new THREE.Vector3(); g.boundingBox.getSize(s);
    const m = Math.max(s.x, s.y);
    camera.position.set(0, -m * 0.9, m * 1.1); controls.target.set(0, 0, 0); controls.update();
  }

  // ---------- Pyodide ----------
  async function boot() {
    try {
      pyodide = await loadPyodide();
      setStatus('Loading 3D engine packages…');
      await pyodide.loadPackage(['numpy', 'scipy', 'pillow', 'shapely']);
      for (const [name, src] of Object.entries(window.VEC2STL_PY)) pyodide.FS.writeFile(name, src);
      await pyodide.runPythonAsync('import configurator_core as cc');
      ready = true;
      setStatus(imgBytes ? 'Ready. Press “Generate preview”.' : 'Ready. Upload your artwork to begin.');
    } catch (e) {
      console.error(e);
      setStatus('');
      showError('The 3D engine could not load in this browser. Try a current Chrome/Safari on a computer, or contact us to order by email.');
    }
    refreshButton();
  }

  // ---------- generate ----------
  genBtn.addEventListener('click', async () => {
    showError(''); quote.hidden = true;
    const w = parseFloat(widthIn.value);
    if (!(w >= 0.5 && w <= 9.5)) { showError('Width must be between 0.5" and 9.5".'); return; }
    genBtn.disabled = true; bar.hidden = false; fill.style.width = '0%';
    const progress = (pct, msg) => { fill.style.width = pct + '%'; setStatus(msg); };
    try {
      pyodide.FS.writeFile('/tmp/' + imgName, imgBytes);
      pyodide.globals.set('_v2s_progress', progress);
      progress(10, 'Generating your stamp… this can take 20–60 seconds. Keep this tab open.');
      await new Promise((r) => setTimeout(r, 30));
      const json = await pyodide.runPythonAsync(
        `import json\njson.dumps(cc.generate(${JSON.stringify('/tmp/' + imgName)}, ${w}, "/tmp/output.stl", _v2s_progress))`);
      const res = JSON.parse(json);
      progress(95, 'Rendering preview…');
      showMesh(pyodide.FS.readFile('/tmp/output.stl').buffer);
      lastResult = res; stale = false;
      applyQuote(res);
      fill.style.width = '100%'; setStatus('Done. Check the preview, then add to cart.');
    } catch (e) {
      console.error(e);
      const msg = String(e && e.message || e);
      const m = msg.match(/ValueError: ([^\n]+)/);
      showError(m ? m[1] : 'Something went wrong generating this design. Try a cleaner image or a different width.');
      setStatus('');
    } finally {
      setTimeout(() => { bar.hidden = true; }, 600);
      refreshButton();
    }
  });

  function applyQuote(res) {
    const type = typeSel.value;                       // "Single" | "Left + Right Set"
    const sku = `V2S-T${res.tier + 1}-${type === 'Single' ? 'S' : 'LR'}`;
    const v = (window.VEC2STL_VARIANTS || {})[sku];
    if (!v) { showError('This size is not available right now. Please contact us.'); return; }
    $('v2s-q-size').textContent = `${res.width_in.toFixed(2)}" × ${res.height_in.toFixed(2)}"`;
    $('v2s-q-area').textContent = `${res.area_in2.toFixed(1)} sq in`;
    $('v2s-q-tier').textContent = `${res.tier + 1} of 9 (up to ${res.tier_max_area} sq in)`;
    $('v2s-q-price').textContent = money(v.price / 100);
    $('v2s-variant').value = v.id;
    $('v2s-p-size').value = `${res.width_in.toFixed(2)} x ${res.height_in.toFixed(2)} in`;
    $('v2s-p-area').value = `${res.area_in2.toFixed(1)} sq in`;
    $('v2s-p-settings').value = JSON.stringify({ v: 1, width_in: parseFloat(widthIn.value), type,
      line_weight_mm: res.line_weight_mm, brim_mm: 2.5, brim_h_mm: 0.5, design_h_mm: 0.7, tier: res.tier + 1 });
    quote.hidden = false;
  }

  form.addEventListener('submit', (e) => {
    if (stale || !$('v2s-variant').value) { e.preventDefault(); showError('Generate the preview first.'); }
    else { $('v2s-cart').disabled = true; $('v2s-cart').textContent = 'Adding…'; }
  });

  // Scripts are deferred; wait for three.js + pyodide to be defined.
  function start() {
    if (typeof THREE === 'undefined' || !THREE.STLLoader || !THREE.OrbitControls || typeof loadPyodide === 'undefined' || !window.VEC2STL_PY) {
      return setTimeout(start, 50);
    }
    initViewer(); boot();
  }
  start();
})();
